import { ReactNode, useEffect } from 'react';

import Button, { Variant } from '~components/Button';
import ModalBase, { ModalBaseProps } from '~components/ModalBase';
import useMedia from '~hooks/useMedia';

import { S } from './style';

export interface ModalProps extends ModalBaseProps {
  title?: string;
  subTitle?: string | ReactNode;
  confirmButtonText?: string;
  handleConfirm?: (value: unknown) => void;
  cancelButtonText?: string;
  handleCancel?: (value: unknown) => void;
  confirmButtonVariant?: Variant;
  onOpen?: () => void;
}

function Modal({
  isOpen,
  handleClose,
  title,
  subTitle,
  handleConfirm,
  handleCancel,
  confirmButtonText,
  cancelButtonText,
  confirmButtonVariant,
  onOpen,
}: ModalProps) {
  const { isMobile } = useMedia();

  useEffect(() => {
    if (isOpen && onOpen) {
      onOpen();
    }
  }, [isOpen]);

  return (
    <ModalBase isOpen={isOpen} handleClose={handleClose} inlineCss={S.Base}>
      {title && <S.Title typography='bold150_B1'>{title}</S.Title>}
      {subTitle &&
        (typeof subTitle === 'string' ? (
          <S.SubTitle typography='midium150_B3' dangerouslySetInnerHTML={{ __html: subTitle }} />
        ) : (
          <S.SubTitle typography='midium150_B3'>{subTitle}</S.SubTitle>
        ))}
      <S.ButtonGroup>
        {cancelButtonText && handleCancel && (
          <Button variant='light' size={isMobile ? 'md' : 'sm'} onClick={handleCancel}>
            {cancelButtonText}
          </Button>
        )}
        <Button
          variant={confirmButtonVariant ?? 'magenta'}
          size={isMobile ? 'md' : 'sm'}
          onClick={handleConfirm}>
          {confirmButtonText}
        </Button>
      </S.ButtonGroup>
    </ModalBase>
  );
}

export default Modal;
